// Event-based navigation system for handling navigation from non-React contexts
// This allows us to trigger navigation from axios interceptors and other utilities

type NavigationEventDetail = {
  path: string;
  state?: unknown;
  replace?: boolean;
};

class NavigationEventEmitter extends EventTarget {
  navigate(path: string, options?: { state?: unknown; replace?: boolean }) {
    const event = new CustomEvent<NavigationEventDetail>('navigate', {
      detail: {
        path,
        state: options?.state,
        replace: options?.replace,
      },
    });
    this.dispatchEvent(event);
  }

  onNavigate(callback: (detail: NavigationEventDetail) => void) {
    const handler = (event: Event) => {
      const customEvent = event as CustomEvent<NavigationEventDetail>;
      callback(customEvent.detail);
    };
    this.addEventListener('navigate', handler);
    return () => this.removeEventListener('navigate', handler);
  }
}

export const navigationEvents = new NavigationEventEmitter();